import React, { useState } from "react";
import { Box, Typography, Tab } from "@mui/material/";
import { TabContext, TabList, TabPanel } from "@mui/lab/";
import { strings } from "../common/i18n";
import Preferences from "./Preferences";
import styles from "./styles";
import Language from "./Language";
import { useHasAdminGroup } from "../common/hooks";

export default () => {
    const isAdmin = useHasAdminGroup();

    const [value, setValue] = useState(isAdmin ? "preferences" : "language");

    const handleChange = (event, newValue) => setValue(newValue);

    return (
        <Box>
            <Box sx={styles.mainHeaderContainer}>
                <Typography variant="h6" sx={styles.tabHeader}>
                    {strings("settings")}
                </Typography>
            </Box>
            <TabContext value={value} sx={styles.tabContext}>
                <Box sx={styles.tabListContainer}>
                    <TabList onChange={handleChange}>
                        {isAdmin && (
                            <Tab
                                label={strings("preferences")}
                                value="preferences"
                            />
                        )}
                        <Tab label={strings("language")} value="language" />
                    </TabList>
                </Box>
                {isAdmin && (
                    <TabPanel value="preferences" sx={styles.tabPanelList}>
                        <Preferences />
                    </TabPanel>
                )}
                <TabPanel value="language" sx={styles.tabPanelList}>
                    <Language />
                </TabPanel>
            </TabContext>
        </Box>
    );
};
